import { render, staticRenderFns } from "./trip-advisor.vue?vue&type=template&id=b91efe24&scoped=true&"
import script from "./trip-advisor.vue?vue&type=script&lang=js&"
export * from "./trip-advisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91efe24",
  null
  
)

export default component.exports